import {
  Close,
  DownloadOutlined,
  FilterAlt,
  ReplayCircleFilled,
} from "@mui/icons-material";
import {
  Input,
  Table,
  Typography,
  Select,
  Button,
  Badge,
  Drawer,
  Checkbox,
  Divider,
  Space,
  Form,
  Tooltip,
  DatePicker,
} from "antd";
import React, { useEffect, useState } from "react";
import "../assets/styles/viewOrganisation.scss";
import {
  getListViewOrg,
  getFilteredOrg,
  getAllOrgName,
  getListAllCities,
  getFilteredOrgDocsDownload,
  getListViewOrgDocsDownload,
  getAof,
  getAllOpsMember,
  commonSearch,
  searchSelect,
} from "../services/httpCalls";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  companyListGlobal,
  opsList,
  orgFilters,
  showloader,
} from "../store/gloabalState";
import useNotify from "../utils/useNotify";
import FileDownload from "js-file-download";
import { useNavigate } from "react-router-dom";
import { EyeOutlined, EditOutlined, FileSyncOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { getProductName } from "../utils/get-product-name";
import _, { create } from "lodash";
import { getProductStatus } from "../utils/get-product-status";
import Cookies from "js-cookie";

const OrganizationNewView = () => {
  const goodEmails = [
    "sonal.mishra@karboncard.com",
    "shubhasheesh@karboncard.com",
    "ashwin@karboncard.com",
    "nilesh@karboncard.com",
    "aditi@karboncard.com",
    "narasingam.m@karboncard.com",
    "yashasavee@karboncard.com",
    "bo@karboncard.com",
    "neema.martin@karboncard.com",
    "devendra.mali@karboncard.com",
    "manvendra.singh@karboncard.com",
    "lakksith.hariie@karboncard.com",
    "raghav.r@karboncard.com",
    "rohini@karboncard.com",
  ];
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [open, setOpen] = useState(false);
  const [alltheCities, setAllTheCities] = useState([]);
  const [filterValues, setFilterValues] = useRecoilState(orgFilters);
  const [searchByType, setSearchByType] = useState("PAN");
  const [queryTermSearch, setQueryTermSearch] = useState("");
  const [filterRefresh, setFilterRefresh] = useState(false);
  const [querySearchRefresh, setQuerySearchRefresh] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [opsMember, setOpsMember] = useRecoilState(opsList);
  const [form] = Form.useForm();
  const setShowLoader = useSetRecoilState(showloader);
  const notify = useNotify();
  const navigate = useNavigate();
  const [userNameList, setUserNameList] = useState([]);
  const [companyList, setCompanyList] = useRecoilState(companyListGlobal);

  const handleAccountSubmissionStatusChange = (val) => {
    const next = { ...filterValues };
    if (val) {
      next.accountSubmissionStatus = val;
    } else {
      delete next.accountSubmissionStatus;
    }
    setFilterValues(next);
    setCurrentPage(0);
    setFilterRefresh(!filterRefresh);
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onCloseDrawer = () => {
    setOpen(false);
  };

  const colsOrg = [
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (val, record) => (
        <div style={{ minWidth: "100px" }}>
          <EditOutlined
            style={{
              color: "#2862FF",
              marginRight: ".8rem",
              fontWeight: "500",
              fontSize: "18px",
            }}
            onClick={() => {
              navigate(`/orgedit/${record.id}`);
            }}
          />
          <EyeOutlined
            onClick={() => navigate(`/orgdetails/${record.id}`)}
            style={{
              color: "#2862FF",
              marginRight: ".8rem",
              fontWeight: "500",
              fontSize: "18px",
            }}
          />
          <FileSyncOutlined
            onClick={() => generateAof(record.id)}
            style={{
              color: "#2862FF",
              fontWeight: "500",
              fontSize: "18px",
            }}
          />
        </div>
      ),

      // < Button type='primary' onClick={() => navigate(`/orgedit/${record.id}`)}> View</Button >
    },
    {
      title: "Company Name",
      key: "name",
      align: "center",
      render: (val, record) =>
        record?.name ? (
          <Link
            to={`/orgdetails/${record.id}`}
            style={{
              color: "#000",
            }}
          >
            {record?.companyType === "SOLE_PRORIETOR"
              ? record?.doingBusinessAs
              : record?.name}
          </Link>
        ) : (
          "----"
        ),
    },
    {
      title: "Product Name",
      align: "center",
      render: (val, record) => getProductName(record),
    },
    {
      title: "Email",
      align: "center",
      render: (val, record) => (record?.orgEmail ? record?.orgEmail : "---"),
    },
    // {
    //     title: "Inward Charges",
    //     align: "center",
    //     width: "160px",
    //     render: (val, record) => {
    //         return <>
    //             <p>FX MRK: {record?.feePlan?.payout[0]?.variable ? record?.feePlan?.payout[0]?.variable + `%` : "-"}</p>
    //             <p>Inv variable: {record?.feePlan?.payout[0]?.variable ? record?.feePlan?.payout[0]?.variable + `%` : "-"}</p>
    //             <p>Fix Amt: {record?.feePlan?.payout[0]?.fixed ? record?.feePlan?.payout[0]?.fixed + `$` : "-"}</p>
    //         </>
    //     }
    // },
    // {
    //     title: "Outward Charges",
    //     align: "center",
    //     width: "160px",
    //     render: (val, record) => {
    //         return <div style={{
    //             padding: 0,
    //             margin: 0
    //         }}>
    //             <p style={{
    //                 padding: 0,
    //                 margin: 0
    //             }}>FX MRK: {record?.outwardFxCharges ? record?.outwardFxCharges + `p` : "-"}</p>
    //             <p style={{
    //                 padding: 0,
    //                 margin: 0
    //             }}>Commision: {record?.outwardCommissionCharges ? record?.outwardCommissionCharges : "-"}</p>
    //             <p style={{
    //                 padding: 0,
    //                 margin: 0
    //             }}>SWIFT: {record?.outwardSwiftCharges ? record?.outwardSwiftCharges : "-"}</p>
    //             <p style={{
    //                 padding: 0,
    //                 margin: 0
    //             }}>15CA: {record["CA15Charges"] ? record["CA15Charges"] : "-"}</p>
    //             <p style={{
    //                 padding: 0,
    //                 margin: 0
    //             }}>15CB: {record["CB15Charges"] ? record["CB15Charges"] : "-"}</p>
    //         </div>
    //     }
    //},
    {
      title: "PAN",
      key: "panNumber",
      align: "center",
      render: (val, record) => (record?.panNumber ? record?.panNumber : "----"),
    },
    {
      title: "GST",
      dataIndex: "gstNumber",
      key: "gsgstNumbert",
      align: "center",
    },
    {
      title: "City/State",
      key: "city",
      align: "center",
      render: (val, record) => {
        let cityList = record?.addresses.length
          ? record?.addresses.filter((val) => val.type === "REGISTERED")
          : [];
        return (
          <div key={cityList[0]?.id}>
            <p>{cityList?.length ? cityList[0]?.city : "----"}</p>
            <p>{cityList?.length ? cityList[0]?.state : "----"}</p>
          </div>
        );
      },
    },
    {
      title: "PartnerStatus",
      dataIndex: "xflowAccountCreationStatus",
      key: "xflowAccountCreationStatus",
      align: "center",
      // render: (val, record) =>
      //   record?.xflowAccountCreationStatus
      //     ? record?.xflowAccountCreationStatus.replaceAll("_", " ")
      //     : "-",
      render: (val, record) => getProductStatus(record),
    },
    {
      title: "Account Submission Status",
      dataIndex: "accountSubmissionStatus",
      key: "accountSubmissionStatus",
      align: "center",
      render: (val, record) => {
        const status =
          typeof record?.accountSubmissionStatus === "string"
            ? record.accountSubmissionStatus
            : typeof val === "string"
            ? val
            : null;
        return status && status.length ? status.replaceAll("_", " ") : "-";
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (val, record) =>
        record?.status ? record?.status.replaceAll("_", " ") : "-",
    },
    {
      title: "Creation Date",
      align: "center",
      render: (val, record) =>
        record?.creationDate ? record?.creationDate : "--",
    },
    {
      title: "Creation By",
      align: "center",
      render: (val, record) => {
        let user = record?.opsUserId
          ? opsMember.filter((x) => x?.value === record.opsUserId)
          : [];
        return (
          <div key={user[0]?.value}>
            {user?.length ? user[0]?.label : "----"}
          </div>
        );
      },
    },
    {
      title: "Submitted By",
      align: "center",
      render: (val, record) => {
        let user = record?.submittedByUserId
          ? opsMember.filter((x) => x?.value === record.submittedByUserId)
          : [];
        return (
          <div key={user[0]?.value}>
            {user?.length ? user[0]?.label : "----"}
          </div>
        );
      },
    },
    {
      title: "Google Lead",
      align: "center",
      render: (val, record) =>
        record?.isGoogleAdsLeads === true ? "Yes" : "No",
    },
  ];
  const selectAfter = (
    <Select
      value={searchByType}
      style={{
        width: "140px",
      }}
      onChange={(e) => setSearchByType(e)}
    >
      <Option value="PAN">PAN</Option>
      <Option value="GST">GST Number</Option>
    </Select>
  );

  const generateAof = async (orgId) => {
    setShowLoader(true);
    await getAof(orgId)
      .then((res) => {
        if (res) {
          notify.success(
            "AOF is successfully sent to opsforex@karboncard.com!"
          );
        }
      })
      .catch((err) => {
        notify.error("Not able to generate AOF. Retry!");
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const hasSpecialCharacters = (value) => {
    const specialCharRegex = /[^a-zA-Z0-9\s]/g;
    return specialCharRegex.test(value);
  };

  const hasSpecialCharactersWithoutComma = (value) => {
    const specialCharRegex = /[^a-zA-Z0-9\s,]/g;
    return specialCharRegex.test(value);
  };

  function isObjEmpty(obj) {
    return (
      Object.values(obj).length === 0 &&
      Object.keys(obj).length === 0 &&
      obj.constructor === Object
    );
  }
  const getListViewofOrganisation = () => {
    setShowLoader(true);
    if (isObjEmpty(filterValues) && queryTermSearch === "") {
      getListViewOrg(currentPage)
        .then((result) => {
          setOrgList([]);
          setOrgList(result.organisationList);
          setTotalCount(result.totalCount);
        })
        .catch((err) => {
          notify.error("Not able to fetch details!");
        })
        .finally(() => setShowLoader(false));
    } else {
      let organisationId = "";
      let gstNumber = "";
      let panNumber = "";
      let isOptInward = "";
      let isOptOutward = "";
      let addressIds = "";
      // let emails = ''
      let toDate = "";
      let fromDate = "";
      let stage = "";
      let submittedBy = "";
      let createdBy = "";
      let userEmail = "";
      let phone = "";
      if (isObjEmpty(filterValues) === false) {
        if (filterValues?.cityListSelection?.length) {
          let cityListSelection = filterValues?.cityListSelection;
          addressIds += cityListSelection;
        }
        if (filterValues?.inward || filterValues?.outward) {
          if (filterValues?.inward && filterValues?.outward) {
            isOptInward = true;
            isOptOutward = true;
          } else if (filterValues?.inward) {
            isOptInward = true;
            isOptOutward = false;
          } else {
            isOptOutward = true;
            isOptInward = false;
          }
        }
        if (filterValues.toFrom?.length) {
          if (filterValues?.toFrom[0]) {
            let dateFormat = "MM/DD/YYYY";
            let date_ = Number(
              new Date(`${filterValues.toFrom[0]?.format(dateFormat)} 00:00:00`)
            );
            fromDate = `${date_}`;
          }
          if (filterValues?.toFrom[1]) {
            let dateFormat = "MM/DD/YYYY";
            let date_ = Number(
              new Date(`${filterValues.toFrom[1]?.format(dateFormat)} 23:59:59`)
            );
            toDate = `${date_}`;
          }
        }
        // if (filterValues?.emailList) {
        //     emails = filterValues?.emailList
        // }
        if (filterValues?.CompanyListSelection?.length) {
          organisationId = filterValues?.CompanyListSelection;
        }
        if (filterValues.stage?.length) {
          stage += filterValues.stage;
        }
        if (filterValues?.submittedByList) {
          submittedBy += filterValues.submittedByList;
        }
        if (filterValues?.createdByList) {
          createdBy += filterValues.createdByList;
        }
        if (filterValues?.emails) {
          userEmail += filterValues.emails;
        }
        if (filterValues?.mobileNumbers) {
          phone += filterValues?.mobileNumbers;
        }
      }
      if (
        hasSpecialCharacters(queryTermSearch) ||
        queryTermSearch.length > 15
      ) {
        notify.error("Please enter a proper value!");
        setShowLoader(false);
        return;
      }
      if (queryTermSearch) {
        if (searchByType === "PAN") {
          panNumber = queryTermSearch.toLowerCase();
        } else if (searchByType === "GST") {
          gstNumber = queryTermSearch.toLowerCase();
        }
      }
      let filterOnlySelected = {
        organisationId: organisationId,
        gstNumber: gstNumber,
        panNumber: panNumber,
        isOptInward: isOptInward,
        isOptOutward: isOptOutward,
        addressIds: addressIds,
        fromDate: fromDate,
        toDate: toDate,
        // orgEmail: emails,
        status: stage,
        createdBy,
        submittedBy,
        userEmail,
        phone,
        accountSubmissionStatus: filterValues?.accountSubmissionStatus || "",
      };
      setShowLoader(true);
      let filters = "";
      Object.keys(filterOnlySelected).forEach((item) => {
        if (filterOnlySelected[item] !== "") {
          filters += `${item}=${filterOnlySelected[item]}&`;
        }
      });
      getFilteredOrg(filters, currentPage)
        .then((res) => {
          setOrgList([]);
          setOrgList(res.organisationList);
          setTotalCount(res.totalCount);
          onCloseDrawer();
        })
        .catch((err) => {
          notify.error("Not able to get filtered Data");
        })
        .finally(() => setShowLoader(false));
    }
  };
  useEffect(() => {
    getListAllCities().then((res) => {
      let cities = res;
      let finalCities;
      if (Object.keys(cities).length) {
        finalCities = Object.keys(cities).map((city, i) => {
          return {
            label: city,
            value: [Object.values(cities)[i]].flat(),
          };
        });
      }
      if (finalCities?.length) {
        let formattedCities = finalCities.map((city) => {
          return {
            label: city?.label,
            value: city?.value.join(","),
          };
        });
        setAllTheCities(formattedCities);
      }
    });
    getAllOpsMember().then((res) => {
      let opsMember = res;
      let finalOps;
      if (Object.keys(opsMember).length) {
        finalOps = Object.keys(opsMember).map((ops, i) => {
          return {
            label: ops,
            value: Object.values(opsMember)[i],
          };
        });
        setOpsMember(finalOps);

        // if (finalOps?.length) {
        //     let formattedOps = finalOps.map((ops) => {
        //         return {
        //             label: ops?.label,
        //             value: ops?.value.join('')
        //         }
        //     })
        // }
      }
    });
  }, []);
  useEffect(() => {
    form.setFieldsValue(filterValues);
    getListViewofOrganisation();
  }, [currentPage, filterRefresh, querySearchRefresh]);

  const onTablePageChange = (pagination) => {
    setCurrentPage(pagination.current - 1);
  };
  const handleFiltersDownload = async () => {
    if (
      Object.keys(filterValues).length === 0 &&
      Object.values(filterValues).length === 0 &&
      queryTermSearch === ""
    ) {
      let defaultFilters = `fromDate=${Number(
        new Date(Date.now() - 2592000000).setHours(0, 0, 0, 0)
      )}&toDate=${Number(Date.now())}`;

      setShowLoader(true);
      await getListViewOrgDocsDownload(defaultFilters)
        .then((res) => {
          if (res !== "" && res !== undefined) {
            FileDownload(res, "organisations.xlsx");
            notify.success("Downloaded!");
          } else {
            notify.error("Not able to download file in given filter!");
          }
        })
        .catch((err) => {
          notify.error("Error while Downloading!");
        })
        .finally(() => {
          setShowLoader(false);
        });
    } else {
      setShowLoader(true);

      let OnlySelectedFilters = {
        organisationId: filterValues?.CompanyListSelection
          ? filterValues?.CompanyListSelection.join(",")
          : "",
        gstNumber: "",
        panNumber: "",
        isOptInward: filterValues?.inward ? filterValues?.inward : "",
        isOptOutward: filterValues?.outward ? filterValues?.outward : "",
        addressIds: filterValues?.cityListSelection
          ? filterValues?.cityListSelection.join(",")
          : "",
        fromDate: filterValues?.toFrom?.[0]
          ? Number(
              new Date(
                `${filterValues.toFrom[0]?.format("MM/DD/YYYY")} 00:00:00`
              )
            )
          : "",
        toDate: filterValues?.toFrom?.[1]
          ? Number(
              new Date(
                `${filterValues.toFrom[1]?.format("MM/DD/YYYY")} 23:59:59`
              )
            )
          : "",
        status: filterValues?.stage ? filterValues?.stage.join(",") : "",
        submittedBy: filterValues?.submittedByList
          ? filterValues?.submittedByList.join(",")
          : "",
        createdBy: filterValues?.createdByList
          ? filterValues?.createdByList.join(",")
          : "",
        userEmail: filterValues?.emails ? filterValues.emails : "",
        phone: filterValues?.mobileNumbers ? filterValues?.mobileNumbers : "",
        accountSubmissionStatus:
          filterValues?.accountSubmissionStatus
            ? filterValues.accountSubmissionStatus
            : "",
      };
      if (filterValues?.inward || filterValues?.outward) {
        if (filterValues?.inward && filterValues?.outward) {
          OnlySelectedFilters.isOptInward = true;
          OnlySelectedFilters.isOptOutward = true;
        } else if (filterValues?.inward) {
          OnlySelectedFilters.isOptInward = true;
          OnlySelectedFilters.isOptOutward = false;
        } else if (filterValues?.outward) {
          OnlySelectedFilters.isOptOutward = true;
          OnlySelectedFilters.isOptInward = false;
        }
      }
      if (queryTermSearch) {
        if (searchByType === "PAN") {
          OnlySelectedFilters.panNumber = queryTermSearch.toLowerCase();
        } else if (searchByType === "GST") {
          OnlySelectedFilters.gstNumber = queryTermSearch.toLowerCase();
        }
      }
      let filters = "";
      Object.keys(OnlySelectedFilters).forEach((item) => {
        if (OnlySelectedFilters[item] !== "") {
          filters += `${item}=${OnlySelectedFilters[item]}&`;
        }
      });
      getFilteredOrgDocsDownload(filters)
        .then((res) => {
          if (res !== "" && res !== undefined) {
            FileDownload(res, "organisations.xlsx");
            notify.success("Downloaded!");
          } else {
            notify.error("Not able to download file in given filter!");
          }
        })
        .catch((err) => {
          notify.error("Error while Downloading!");
        })
        .finally(() => setShowLoader(false));
    }
  };

  // const debounceOpsMemberSearchFetch = _.debounce((opsMemberName) => {
  //     searchSelect(opsMemberName, "user/v1/search?")
  //     .then((res) => {
  //         // const finalOpsMemberList = res.map()
  //         const finalOpsList = res.map((member) => {
  //             if(member?.name && member?.id) {
  //             return {
  //                 label: member.name,
  //                 value: member.id
  //             }
  //         }
  //         return false;
  //         })

  //         setOpsMemberList(finalOpsList)
  //     })
  // },500)

  // const handleOpsMemberSearch = (e) => {
  //     const opsMemberName = e.target.value;
  //     debounceOpsMemberSearchFetch(opsMemberName)
  // }

  // debouncing company legal name and dba search
  const debounceCompanySearchFetch = _.debounce((companyName) => {
    searchSelect(companyName, "organisation/v1/search?").then((res) => {
      const finalCompanyList = res.map((company) => {
        return {
          label: `${company.name} ${
            company?.doingBusinessAs ? `(${company.doingBusinessAs})` : ""
          }`,
          value: company?.id,
        };
      });
      setCompanyList(finalCompanyList);
    });
  }, 500);

  const handleCompanySearch = (e) => {
    const companyName = e.target.value;
    const specialCharRegex = /^[^+=?<>*%$#!]*$/;

    if (specialCharRegex.test(companyName)) {
      form.setFields([
        {
          name: "CompanyListSelection",
          errors: [],
        },
      ]);
      debounceCompanySearchFetch(companyName);
    } else {
      form.setFields([
        {
          name: "CompanyListSelection",
          errors: ["No special characters allowed!"],
        },
      ]);
    }
  };

  const stagesFilter = [
    {
      label: "Draft Corporate Details",
      value: "DRAFT_CORPORATE_DETAILS",
    },
    {
      label: "Draft Corporate Docs",
      value: "DRAFT_CORPORATE_DOCS",
    },
    {
      label: "Draft Auth Signatory",
      value: "DRAFT_AUTH_SIGNATORY",
    },
    {
      label: "Draft Shareholders",
      value: "DRAFT_SHAREHOLDERS",
    },
    {
      label: "Verifying",
      value: "VERIFYING",
    },
    {
      label: "Input Required",
      value: "INPUT_REQUIRED",
    },
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "Suspended",
      value: "SUSPENDED",
    },
    {
      label: "Disabled",
      value: "DISABLED",
    },
    {
      label: "Phone verified",
      value: "PHONE_VERIFIED",
    },
    {
      label: "Company type entered",
      value: "COMPANY_TYPE_ENTERED",
    },
    {
      label: "Pan entered",
      value: "PAN_ENTERED",
    },
    {
      label: "Draft registered address",
      value: "DRAFT_REGISTERED_ADDRESS",
    },
    {
      label: "Draft bank details",
      value: "DRAFT_BANK_DETAILS",
    },
  ];

  return (
    <div className="org">
      <div className="org_heading">
        <Typography.Title level={2}>Organisations</Typography.Title>
      </div>
      <div
        className="org_filters-container"
        style={{
          margin: "20px 0",
        }}
      >
        <div
          className="org_filters-container_searchbox"
          style={{ margin: "15px 0" }}
        >
          <Input
            style={{
              width: "500px",
              margin: "0 10px",
            }}
            maxLength={100}
            addonAfter={selectAfter}
            onChange={(e) => {
              setQueryTermSearch(e.target.value);
            }}
            placeholder="Search by PAN,GST"
            value={queryTermSearch ? queryTermSearch : ""}
          />
          <Button
            type="primary"
            onClick={() => {
              if (queryTermSearch) {
                setQuerySearchRefresh(!querySearchRefresh);
              } else {
                notify.error("Please enter PAN or GST to be searched!");
              }
            }}
          >
            Search
          </Button>
          <Tooltip title="Resets all the filter states and sync with original data">
            <Button
              icon={<ReplayCircleFilled />}
              type="ghost"
              style={{ margin: "0 5px" }}
              onClick={() => {
                form.resetFields();
                setFilterValues({});
                setQuerySearchRefresh(!querySearchRefresh);
                setQueryTermSearch("");
                setSearchByType("PAN");
                setCurrentPage(0);
              }}
            >
              RESET
            </Button>
          </Tooltip>
          <Select
            allowClear
            style={{ width: 260, marginLeft: 8 }}
            placeholder="Select account submission status"
            options={[
              {
                label: "PENDING SUBMISSION BY BD AM",
                value: "PENDING_SUBMISSION_BY_BD_AM",
              },
              {
                label: "SUBMITTED BY BD AM",
                value: "SUBMITTED_BY_BD_AM",
              },
              {
                label: "DRAFT SAVED FOR REVIEW BY OPS",
                value: "DRAFT_SAVED_FOR_REVIEW_BY_OPS",
              },
              {
                label: "FINAL SUBMISSION DONE",
                value: "FINAL_SUBMISSION_DONE",
              },
            ]}
            onChange={handleAccountSubmissionStatusChange}
            value={filterValues?.accountSubmissionStatus || undefined}
          />
        </div>

        <div className="org_filters-container_wrapButtons">
          <div className="org_filters-container_filterButton">
            <Badge count={Object.keys(filterValues)?.length ? 1 : 0}>
              <Button
                type="primary"
                icon={<FilterAlt />}
                onClick={showDrawer}
              ></Button>
            </Badge>
          </div>
          {goodEmails.includes(
            JSON.parse(Cookies.get("userInfo"))?.email?.toLowerCase()
          ) && (
            <div className="org_filters-container_downloadButton">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleFiltersDownload}
              >
                Download
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="org_table">
        <Table
          columns={colsOrg}
          dataSource={orgList}
          className="styledAntd"
          pagination={{
            pageSize: 10,
            total: totalCount,
            showSizeChanger: false,
            position: ["bottomCenter"],
            current: currentPage + 1,
          }}
          onChange={onTablePageChange}
          rowKey={(record) => Math.random() + record?.id}
          scroll={{ x: "100vw" }}
        />
      </div>
      <Drawer
        title={
          <Typography.Title
            level={4}
            style={{
              margin: 0,
              padding: 0,
              textTransform: "uppercase",
            }}
          >
            Table Filters
          </Typography.Title>
        }
        placement="right"
        onClose={onCloseDrawer}
        closable={false}
        open={open}
        extra={
          <Space>
            <Button
              icon={<Close />}
              type="ghost"
              onClick={onCloseDrawer}
            ></Button>
          </Space>
        }
        size={"default"}
      >
        <Form
          onFinish={(value) => {
            setCurrentPage(0);
            setFilterValues(value);
            setFilterRefresh(!filterRefresh);
            onCloseDrawer();
          }}
          form={form}
          layout="vertical"
        >
          <div className="product-type" style={{}}>
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Filter by Product Type
            </Typography.Title>
            <div
              className="product-checkbox"
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              <Form.Item
                name={"outward"}
                valuePropName="checked"
                style={{ margin: 0 }}
              >
                <Checkbox value={"outward"}>Outward</Checkbox>
              </Form.Item>
              <Form.Item
                name={"inward"}
                valuePropName="checked"
                style={{ margin: 0 }}
              >
                <Checkbox value={"inward"}>Inward</Checkbox>
              </Form.Item>
            </div>
          </div>

          <Divider />
          <div className="datefilter">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Filter by Date{" "}
            </Typography.Title>
            <Form.Item
              label="Select Date Range"
              tooltip="Provide from and to date"
              name={"toFrom"}
            >
              <RangePicker />
            </Form.Item>
          </div>
          <Divider />
          <div className="companyList">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Filter by Companies{" "}
            </Typography.Title>
            <Form.Item
              name="CompanyListSelection"
              label="Search Companies"
              tooltip={`Search and select companies`}
              onChange={handleCompanySearch}
            >
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select companies you want to filter"
                optionLabelProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={companyList ? companyList : []}
                value={
                  filterValues?.CompanyListSelection
                    ? filterValues.CompanyListSelection
                    : []
                }
              ></Select>
            </Form.Item>
          </div>
          <Divider />
          {/* <div className="userNameList">
                        <Typography.Title level={5} style={{
                            textTransform: "uppercase",

                        }}>Filter by User names </Typography.Title>
                        <Form.Item name="userNameListSelection" label='Search User Names' tooltip={`Search and select user names`}>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Select user names you want to filter"
                                optionLabelProp="label"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={[]}
                            >
                            </Select>
                        </Form.Item>
                    </div>
                    <Divider /> */}
          <div className="emails">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Filter by emails
            </Typography.Title>
            <Form.Item
              name="emails"
              label="Enter comma separated emails"
              tooltip={`Search and select emails`}
              rules={[
                {
                  validator: (_, value) => {
                    if (value && value.length > 100) {
                      return Promise.reject(
                        "Input cannot be more than 100 characters"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                style={{ width: "100%" }}
                placeholder="enter emails you want to filter"
              />
            </Form.Item>
          </div>
          <Divider />
          <div className="mobileNumberList">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Filter by Mobile numbers
            </Typography.Title>
            <Form.Item
              name="mobileNumbers"
              label="Enter comma separated mobile numbers"
              tooltip={`Search and select mobile numbers`}
              rules={[
                {
                  validator: (_, value) => {
                    if (value && hasSpecialCharactersWithoutComma(value)) {
                      return Promise.reject(
                        new Error("No special characters allowed!")
                      );
                    }

                    if (value && value < 0) {
                      return Promise.reject(
                        new Error("Value cannot be negative")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                style={{ width: "100%" }}
                placeholder="enter mobile numbers you want to filter"
                value={
                  filterValues?.mobileNumbers ? filterValues.mobileNumbers : ""
                }
              ></Input>
            </Form.Item>
          </div>
          <Divider />
          <div className="createdByList">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Created By
            </Typography.Title>
            <Form.Item
              name="createdByList"
              label="Search Ops/BD Members"
              tooltip={`Search and select ops members`}
            >
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select ops/BD members you want to filter"
                optionLabelProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={opsMember ? opsMember : []}
              ></Select>
            </Form.Item>
          </div>
          <Divider />
          <div className="submittedByList">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Submitted By
            </Typography.Title>
            <Form.Item
              name="submittedByList"
              label="Search Ops/BD Members"
              tooltip={`Search and select ops members`}
            >
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select ops/BD members you want to filter"
                optionLabelProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={opsMember ? opsMember : []}
              ></Select>
            </Form.Item>
          </div>
          <Divider />
          <div className="filterbycity">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Filter by City{" "}
            </Typography.Title>
            <Form.Item
              name="cityListSelection"
              label="Search Cities"
              tooltip={`Search and select cities`}
            >
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select cities you want to filter"
                optionLabelProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={alltheCities?.length ? alltheCities : []}
              ></Select>
            </Form.Item>

            {/* <div className='cityList'>
                            <Form.Item name={'defaultCities'} label="Most used Cities">
                                <Checkbox.Group >
                                    <Row gutter={[16, 16]}>
                                        <Col span={16}>
                                            <Checkbox value="A">BANGALORE</Checkbox>
                                        </Col>
                                        <Col span={16}>
                                            <Checkbox value="B">MUMBAI</Checkbox>
                                        </Col>
                                        <Col span={16}>
                                            <Checkbox value="C">DELHI</Checkbox>
                                        </Col>
                                        <Col span={16}>
                                            <Checkbox value="D">PUNE</Checkbox>
                                        </Col>
                                        <Col span={16}>
                                            <Checkbox value="E">KOLKATA</Checkbox>
                                        </Col>
                                    </Row>
                                </Checkbox.Group>
                            </Form.Item>
                        </div> */}
          </div>
          <Divider />
          <div className="filterbyStage">
            <Typography.Title
              level={5}
              style={{
                textTransform: "uppercase",
              }}
            >
              Filter by Stage{" "}
            </Typography.Title>
            <Form.Item
              name="stage"
              label="Search Stage"
              tooltip={`Search and select Stages`}
            >
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select stage(s) you want to filter by"
                optionLabelProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={stagesFilter}
              ></Select>
            </Form.Item>
          </div>
          <Divider />
          <Space>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                setFilterValues({});
                setFilterRefresh(!filterRefresh);
                setCurrentPage(0);
                onCloseDrawer();
              }}
            >
              Reset All
            </Button>
          </Space>
        </Form>
      </Drawer>
    </div>
  );
};

export default OrganizationNewView;
